import React from 'react';
import { injectIntl } from 'react-intl';
import { Button, InputGroup } from 'react-bootstrap';
import FormInput from 'components/forms/FormInput';
import { getGrossFromNet, getNetFromGross } from 'helpers/financial';

class FormPriceNetGross extends React.Component {
  state = {
    isNetPrice: true,
  };

  switchNetGross = () => {
    const { isNetPrice } = this.state;
    this.setState({ isNetPrice: !isNetPrice });
  };

  /**
   * Callback for the FormInput component
   * receives the value and passes it up to the callback in props.
   * @param {string} _name ignored
   * @param {*} value input value
   */
  handleChange = (_name, value) => {
    const { vatRate, onChange } = this.props;
    const { isNetPrice } = this.state;
    const price = Number(value);
    const result = isNetPrice ? price : getNetFromGross(price, vatRate);
    onChange(result);
  };

  render() {
    const {
      netValue,
      vatRate,
      intl: { messages },
    } = this.props;
    const { switchNetGross, handleChange } = this;
    const { isNetPrice } = this.state;
    const netOrGross = isNetPrice ? messages.net : messages.gross;
    const value = isNetPrice ? netValue : getGrossFromNet(netValue, vatRate);

    return (
      <InputGroup>
        <InputGroup.Button>
          <Button disabled>&euro;</Button>
        </InputGroup.Button>
        <FormInput
          type="number"
          name="price"
          value={value}
          onChange={handleChange}
          style={{ height: '35px', minHeight: '35px' }}
        />
        <InputGroup.Button>
          <Button onClick={switchNetGross}>{netOrGross}</Button>
        </InputGroup.Button>
      </InputGroup>
    );
  }
}

export default injectIntl(FormPriceNetGross);
